import apiService from 'src/shared/config/apiService';
import { BuilderStep, Rfq } from 'src/shared/types/rfq';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateRfqStepPayload = {
  rfq_id: number;
  builder_step: BuilderStep;
};

export const updateRfqStep = async (
  payload: UpdateRfqStepPayload
): Promise<Rfq> => {
  try {
    const { data } = await apiService.patch(`/rfqs/${payload.rfq_id}`, {
      builder_step: payload.builder_step
    });

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
